import { SourcingInternalSelectedCandidateProfileQueryItem } from 'modules/sourcing-internal/tables/types/SourcingInternalSelectedCandidateProfileQueryItem';
import { SourcingInternalSelectedCandidateProfileTableData } from 'modules/sourcing-internal/tables/types/SourcingInternalSelectedCandidateProfileTableData';
import { DuplicateCandidateProfileResult } from '../hooks/useSourcingInternalCandidateProfileDuplicateCheck';

type MapSourcingInternalSelectedCandidateProfilesToTableColumnsProps = {
  data: SourcingInternalSelectedCandidateProfileQueryItem[];
  duplicateCandidateProfileResults: DuplicateCandidateProfileResult[];
};

export const mapSourcingInternalSelectedCandidateProfilesToTableColumns = ({
  data,
  duplicateCandidateProfileResults
}: MapSourcingInternalSelectedCandidateProfilesToTableColumnsProps): SourcingInternalSelectedCandidateProfileTableData[] => {
  const duplicateResultsMap = new Map(
    duplicateCandidateProfileResults.map((result) => [
      result.candidateProfileId,
      result
    ])
  );

  return data.map((item) => {
    const profileId = item.candidateProfile?.id;
    const duplicateCandidateProfileResult = profileId
      ? duplicateResultsMap.get(profileId)
      : undefined;

    const inviteStatus = duplicateCandidateProfileResult?.hasAnalysedInvite
      ? 'applied'
      : duplicateCandidateProfileResult?.hasSourcedInvite
      ? 'invited'
      : null;

    return {
      id: profileId ?? '',
      selectionId: item.id ?? '',
      name: `${item.candidateProfile?.firstName ?? ''} ${
        item.candidateProfile?.lastName ?? ''
      }`.trim(),
      location: item.candidateProfile?.location?.name ?? '',
      currentRole:
        item.candidateProfile?.jobs?.find((job) => job.currentRole)
          ?.companyName ?? '',
      email: item.candidateProfile?.email ?? '',
      phone: item.candidateProfile?.phoneNumber ?? '',
      inviteStatus
    };
  });
};
